import { render, staticRenderFns } from "./_footer.vue?vue&type=template&id=b0672228&scoped=true"
import script from "./_footer.vue?vue&type=script&lang=js"
export * from "./_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0672228",
  null
  
)

export default component.exports